module.exports = __webpack_public_path__ + "img/midBox_mark_dark.5345dfe0.png";